import React from 'react'
import { Breadcrumb } from 'antd'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { store } from '../../../../store'
import styles from './Breadcrumbs.module.scss'

interface Props {
}

export const PageBreadcrumbs = observer(({}: Props) => {
  return (
    <div className={styles.root}>
      <Breadcrumb>
        {store.ui.breadcrumbs.map((bc, idx) => (
          <Breadcrumb.Item key={bc.url || idx}>
            {
              bc.url && idx !== store.ui.breadcrumbs.length - 1
                ? <Link to={bc.url}>{bc.title}</Link>
                : <span>{bc.title}</span>
            }
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  )
})
